/**
 * PATH: apps/inventory/src/pages/ItemsPage.tsx
 * PURPOSE: Inventory items management
 */
import { EmptyRegister } from './emptyRegister'

export default function ItemsPage() {
  return (
    <EmptyRegister
      title="Inventory Items"
      detail="No stock items are connected."
    />
  )
}
